export default __webpack_public_path__ + "static/media/icon_invite_num.fa29f390.svg";